import React, { Component } from 'react';
import { Card, CardHeader, CardBody, Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import InformationDialog from 'components/markdowndialog';

class DefaultContainer extends Component {

  constructor(props) {
    super(props);

    this.informationDialog = React.createRef();
  }

  showInfoDialog() {
    this.informationDialog.current.show(this.props.uriDoc);
  }


  render() {
    return (
      <div className={this.props.className + " animated fadeIn"} >
        <InformationDialog ref={this.informationDialog} />
        <Row>
          <Col lg="12">
            <Card>
              <CardHeader>
                <i className="fa fa-align-justify"></i><span>{this.props.title}</span>
                <div className="card-header-actions">

                  {this.props.actions && this.props.actions.map((action, index) => {
                    return action.render
                      ? action.render(index)
                      : (<Button key={index} className="ml-1" color="ghost-primary" size="sm" onClick={() => action.action(index)}>{action.dynamicLabel ? action.dynamicLabel(index) : action.label}</Button>)
                  })}

                  {this.props.uriDoc && (
                    <Button className="ml-1" color="ghost-primary" size="sm" title="Info" onClick={this.showInfoDialog.bind(this)}><i className="fa fa-question" /></Button>
                  )}
                </div>
              </CardHeader>
              <CardBody>
                {this.props.children}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

}

DefaultContainer.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      dynamicLabel: PropTypes.func,
      action: PropTypes.func,
      render: PropTypes.func
    })),
  uriDoc: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
}

DefaultContainer.defaultProps = {
  className: ''
};

export default DefaultContainer;
